import { render, staticRenderFns } from "./lucky-draw-more.vue?vue&type=template&id=32928736&scoped=true&"
import script from "./lucky-draw-more.vue?vue&type=script&lang=js&"
export * from "./lucky-draw-more.vue?vue&type=script&lang=js&"
import style0 from "./lucky-draw-more.vue?vue&type=style&index=0&id=32928736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32928736",
  null
  
)

export default component.exports